import { render, staticRenderFns } from "./ModuloList.vue?vue&type=template&id=398c30c0&scoped=true&"
import script from "./ModuloList.vue?vue&type=script&lang=js&"
export * from "./ModuloList.vue?vue&type=script&lang=js&"
import style0 from "./ModuloList.vue?vue&type=style&index=0&id=398c30c0&lang=scss&scoped=true&"
import style1 from "./ModuloList.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "398c30c0",
  null
  
)

export default component.exports